import React, { forwardRef } from 'react';

import type { GenderNullableParameter } from '@vlabs/api/luna-api/model';
import { GENDER_OPTIONS } from '@vlabs/api-bindings/src/constants';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { Radio } from '@vlabs/uikit/components/controls/radio';

import { useWorkspaceFilters } from '../../useWorkspaceFilters';
import st from '../FilterPopovers.module.sass';

interface GenderOption {
  label: string;
  value: GenderNullableParameter;
}

function GenderFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { filters, updateFilters } = useWorkspaceFilters();

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={filters.gender === undefined}
      onClickReset={() => updateFilters({ gender: undefined })}
      ref={ref}
    >
      <div className={st.RadioWrapper}>
        {(GENDER_OPTIONS.raw as GenderOption[]).map((option) => (
          <Radio
            checked={filters.gender?.value === option.value}
            key={option.value}
            label={option.label}
            onChange={() => updateFilters({ gender: option })}
          />
        ))}
      </div>
    </PopoverWithButton>
  );
}

const GenderFilterPopoverWithRef = forwardRef(GenderFilterPopover);
export { GenderFilterPopoverWithRef as GenderFilterPopover };
